import { render } from "./Diferenciais.vue?vue&type=template&id=5e509a47"
import script from "./Diferenciais.vue?vue&type=script&lang=js"
export * from "./Diferenciais.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__